import gql from 'graphql-tag'

export const APP_MOBILE_REPORT = gql`
    query($input: AppMobileReportInput!) {
        appMobileReport(input: $input)
    }
`
